/**
 * Helpers for turning thrown API errors into user-facing messages.
 *
 * SDK calls throw a structured `ApiError` (`{ status, body }`) rather than an
 * `Error` instance (see `./client`), so `err instanceof Error` never matches.
 * `getApiErrorMessage` digs out FastAPI's `{ detail: "..." }` payload when it's
 * a non-empty string, falling back to a caller-supplied message otherwise.
 */

import type { ApiError } from "./client";

export function getApiErrorMessage(err: unknown, fallback: string): string {
  const body = (err as ApiError | undefined)?.body;
  if (body && typeof body === "object" && "detail" in body) {
    const detail = (body as { detail?: unknown }).detail;
    if (typeof detail === "string" && detail.trim() !== "") {
      return detail;
    }
  }
  return fallback;
}
